import { Chip, Typography } from "@mui/material";
import useEffectAsync from "../../../lib/helper/useEffectAsync";
import { httpClient } from "../../../lib/HttpClient";
import * as Yup from 'yup';
import { useFormik } from "formik";
import { toast } from "react-toastify";
import useTranslation from  "../../../lib/localization";
import LayoutWithSidebar from "../../../components/LayoutWithSidebar";
import CopyToMemory from '../../../components/CopyToClipboard'

export default function TelegramNotificationConfig() {
    const t = useTranslation();
    var schema = Yup.object({
        paymentSettings: Yup.object({
            paymentApprovalMargin: Yup.number().min(0).required(t("shared.mandatory"))
        })
    })
    var formik = useFormik({
        validationSchema: schema,
        initialErrors: false,
        initialValues: {
            activationToken: '',
            chatId: ''
        }
    })

    useEffectAsync(async () => {
        try {
            var response = await httpClient.Get("/api/notificationSettings/activate?channelName=telegram");
            


            formik.setValues(response);
        } catch (error) {
            toast.error(error.toString())
        }
    }, [])
    return (
        <LayoutWithSidebar>
            <Typography>
                In order to receive notification messages from Telegram bot please send a message
                to <a target='_blank' href="https://t.me/carawaybot" >@carawaybot</a> containing :
                &nbsp;
                <CopyToMemory text={formik.values.activationToken}>
                        <Chip sx={{ borderRadius: '10px', borderStyle: 'dashed', borderWidth: '1px' }} 
                        label={`${formik.values.activationToken.toUpperCase()}`} />
                </CopyToMemory> .
            </Typography>
        </LayoutWithSidebar>
    )

}